import { formatInvoiceDueDate } from "@/modules/billing/invoiceEmailTemplate";

export const buildTicketSendFooterSummary = (
  amountFormatted: string,
  dueDate: string,
) => `${amountFormatted} due ${formatInvoiceDueDate(dueDate)}`;
